<template>
    <div v-if="message.type === 'file' || message.type === 'imagem' || message.type === 'video' || message.type === 'sticker' || (message.type == 'template_meta' && message.fileData?.mimeType.startsWith('image'))">
        <div v-if="message.fileData?.mimeType.startsWith('image/') || message.type === 'imagem' || message.type === 'sticker'"
            class="image-message cursor-pointer position-relative"
            :class="{ 'sticker-wrapper': message.subtype === 'sticker' }"
            @click.stop="openImageModal">

            <img v-if="message.fileData?.url && !mediaLoadFailed"
                :src="message.fileData?.url"
                @error="mediaLoadFailed = true"
                class="img-fluid rounded mb-1 chat-media-fixed"
                :class="{ 'sticker': message.subtype == 'sticker' }"
                alt="Imagem">

            <div v-else-if="midiaAindaCarregando" class="media-carregando">
                <img v-if="miniatura" :src="miniatura" class="media-carregando__miniatura" alt="" />
                <div class="media-carregando__aviso">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Carregando mídia…</span>
                </div>
            </div>

            <div v-else-if="!message.uploadError && message.readStatus !== 'pending'"
                class="media-load-failed d-flex flex-column align-items-center justify-content-center text-muted">
                <i class="ri-image-off-line fs-2 mb-1"></i>
                <span class="font-size-12">Não foi possível carregar a imagem</span>
            </div>

            <div v-if="message.readStatus === 'pending' || message.uploadError" class="modern-state-overlay" :class="{'is-failed': message.uploadError}">

                <div v-if="!message.uploadError" class="d-flex flex-column align-items-center">
                    <div class="spinner-border text-light mb-2" role="status" style="width: 2rem; height: 2rem; border-width: 3px;"></div>
                    <span class="text-white fw-medium shadow-sm" style="font-size: 12px; text-shadow: 1px 1px 2px rgba(0,0,0,0.5);">Enviando...</span>
                </div>

                <div v-else class="failed-action-box" @click.stop="emit('retry:failed-message', message as Message)" title="Tentar novamente">
                    <div class="retry-circle">
                        <i class="ri-refresh-line text-white"></i>
                    </div>
                    <span class="failed-text">Falha no envio.<br>Clique para repetir</span>
                </div>
            </div>

            <p v-if="message.fileData?.caption" class="mb-0 message-text pt-1" v-html="formatCaption(message.fileData.caption)" @click.stop="handleCaptionClick"></p>
        </div>
        <div v-else-if="message.fileData?.mimeType.startsWith('video/')" class="image-message position-relative" @mouseenter="warmVideoBuffer">
            <VideoDeChat v-if="message.fileData?.url && !mediaLoadFailed"
                :src="message.fileData.url"
                @error="videoStall.onError"
                @waiting="videoStall.onStall"
                @stalled="videoStall.onStall"
                @playing="videoStall.onPlaying"
                class="img-fluid rounded mb-1"
                controls
                :preload="videoPreload"
                style="max-height: 300px; width: 100%; object-fit: contain; background-color: rgba(0,0,0,0.1);"
            ></VideoDeChat>
            <div v-else-if="midiaAindaCarregando" class="media-carregando">
                <img v-if="miniatura" :src="miniatura" class="media-carregando__miniatura" alt="" />
                <div class="media-carregando__aviso">
                    <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span>Carregando mídia…</span>
                </div>
            </div>
            <div v-else-if="message.readStatus !== 'pending'"
                class="media-load-failed d-flex flex-column align-items-center justify-content-center text-muted">
                <i class="ri-video-off-line fs-2 mb-1"></i>
                <span class="font-size-12">Não foi possível carregar o vídeo</span>
            </div>
            <div v-if="message.readStatus === 'pending'" class="media-loading-overlay">
                <div class="spinner-border text-white" role="status" style="width: 1.5rem; height: 1.5rem; border-width: 2px;"></div>
            </div>
            <p v-if="message.fileData?.caption" class="mb-0 message-text pt-1" v-html="formatCaption(message.fileData.caption)" @click.stop="handleCaptionClick"></p>
        </div>

        <div v-else class="file-message-card position-relative transition-all"
            :class="{'is-failed-card': message.uploadError, 'cursor-pointer': !message.uploadError || arquivoNoStorage}"
            @click="(!message.uploadError || arquivoNoStorage) && openDocument(message.fileData?.url)">

            <div v-if="message.readStatus === 'pending' && !message.uploadError" class="file-state-overlay">
                <div class="spinner-border text-primary" role="status" style="width: 1.2rem; height: 1.2rem; border-width: 2px;"></div>
            </div>

            <div class="file-card-inner d-flex align-items-center p-2">

                <div class="file-icon rounded d-flex align-items-center justify-content-center"
                    style="width: 45px; height: 45px;"
                    :class="message.uploadError ? 'bg-danger-subtle' : 'bg-primary-subtle'">
                    <i v-if="message.uploadError" class="ri-error-warning-fill text-danger fs-3"></i>
                    <i v-else class="ri-file-text-fill text-primary fs-3"></i>
                </div>

                <div class="file-info ms-3 flex-grow-1 overflow-hidden" style="min-width: 120px;">
                    <span class="file-name text-truncate d-block mb-1 font-size-14"
                        :class="{'text-danger fw-bold': message.uploadError}">
                        {{ message.fileData?.name }}
                    </span>
                    <span class="file-meta text-muted font-size-12 d-block">
                        <span v-if="message.uploadError" class="text-danger opacity-75 fw-medium">Falha ao enviar</span>
                        <span v-else-if="!message.fileData?.url" class="text-danger opacity-75 fw-medium">Arquivo indisponível</span>
                        <span v-else>{{ message.fileData?.size || 'Desconhecido' }}</span>
                    </span>
                </div>

                <div class="ms-3 ps-2 border-start" :class="message.uploadError ? 'border-danger-subtle' : ''">

                    <button v-if="message.uploadError"
                            class="btn btn-sm btn-icon rounded-circle retry-btn-modern"
                            @click.stop="emit('retry:failed-message', message as Message)"
                            title="Tentar novamente">
                        <i class="ri-refresh-line fs-5"></i>
                    </button>

                    <button v-if="!message.uploadError || arquivoNoStorage"
                            class="btn-download-file"
                            @click.stop="downloadFile(message.fileData?.url, message.fileData?.name)">
                        <i class="ri-download-2-line"></i>
                    </button>
                </div>
            </div>

            <p v-if="message.fileData?.caption" class="mb-0 message-text pt-1" v-html="formatCaption(message.fileData.caption)" @click.stop="handleCaptionClick"></p>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ChatMessageType, ChatReadStatus, FileData, Message } from '@/mocks/app/mockChatData';
import { useUiStore } from '@/stores/app/uiStore';
import { useChatStore } from '@/stores/app/chatStore';
import { useVideoStallRecovery } from '@/composables/useVideoStallRecovery';
import VideoDeChat from './VideoDeChat.vue';
import { computed, PropType, ref } from 'vue';
import { escapeHtml } from '@/utils/escapeHtml';

const props = defineProps({
    message: { type: Object as PropType<{
        type: ChatMessageType,
        subtype?: 'sticker' | undefined,
        readStatus?: ChatReadStatus,
        fileData?: FileData,
        uploadError?: boolean,
    } | Message>, required: true }
})

const emit = defineEmits({
    'retry:failed-message'(msg: Message) { return msg },
})

// Arquivo que já subiu para o storage (URL http/https, não blob local). Mensagem com
// falha de ENVIO continua com o arquivo acessível: desde que o botão "Reenviar" passou
// a existir após recarregar, `uploadError` também marca documento vindo do servidor, e
// ele não pode tirar do operador o acesso ao próprio arquivo.
const arquivoNoStorage = computed(() => /^https?:/.test(props.message.fileData?.url ?? ''));

const uiStore = useUiStore();
const chatStore = useChatStore();

// Sinaliza falha de carregamento da mídia (url vazia/quebrada/404) para exibir indicador visível
const mediaLoadFailed = ref(false);

// Mídia recebida ainda SEM url: está no reparo assíncrono do servidor e chega por
// `MENSAGEM.MIDIA` (docs/specs/midia-assincrona.md). Perda de mídia não passa por
// aqui — vira TEXTO com `ehMediaPerdida` —, então sem url não é "falhou", é
// "ainda não chegou". O ChatMessage já desvia `midiaPendente` antes deste
// componente; isto cobre a mensagem que chegou sem a marca (ex.: evento anterior
// ao deploy), para o operador ver "carregando" e não um erro. Url que existe e
// falha ao carregar continua indo para o aviso de erro (`mediaLoadFailed`).
const midiaAindaCarregando = computed(() =>
    !props.message.fileData?.url
    && !props.message.uploadError
    && props.message.readStatus !== 'pending'
);
const miniatura = computed(() => (props.message as Message).miniatura);

// Vídeo começa com preload="metadata" (só cabeçalho) e sobe para "auto" quando o
// operador passa o mouse sobre o balão — o buffer inicia antes do clique em play,
// reduzindo a espera percebida sem baixar vídeos que nunca serão assistidos.
const videoPreload = ref<'metadata' | 'auto'>('metadata');

function warmVideoBuffer(): void {
    videoPreload.value = 'auto';
}

// Recupera o player quando o download do vídeo trava no meio (stall de rede);
// só marca falha definitiva quando o src é irrecuperável (404/codec).
const videoStall = useVideoStallRecovery(() => { mediaLoadFailed.value = true; });

function formatCaption(caption: string): string {
    if (!caption) return '';

    const applyFormatting = (s: string): string => {
        if (!s) return '';
        s = s.replace(/\*([^*\n]+)\*/g, '<b>$1</b>');
        s = s.replace(/(^|\s)_([^_]+)_(?=$|\s|[.,!?])/g, '$1<i>$2</i>');
        s = s.replace(/~([^~]+)~/g, '<s>$1</s>');
        s = s.replace(/```([^`]+)```/g, '<code class="chat-code">$1</code>');
        return s.replace(/\n/g, '<br />');
    };

    const resolveDisplayName = (digits: string): string | null => {
        const contato =
            chatStore.contatosByCodigo.get(digits)
            ?? chatStore.contatosByCodigo.get(digits.replace(/^55(\d{2})9(\d{8})$/, '55$1$2'))
            ?? chatStore.contatosByCodigo.get(digits.replace(/^55(\d{2})(\d{8})$/, '55$19$2'));
        if (contato?.nome) return contato.nome;

        const participants = chatStore.activeChat?.participants ?? [];
        const participant =
            participants.find(p => p.phone.replace(/\D/g, '') === digits)
            ?? participants.find(p => p.phone.replace(/\D/g, '') === digits.replace(/^55(\d{2})9(\d{8})$/, '55$1$2'))
            ?? participants.find(p => p.phone.replace(/\D/g, '') === digits.replace(/^55(\d{2})(\d{8})$/, '55$19$2'));
        if (participant?.name) return participant.name;

        return null;
    };

    const tokenRegex = /@[\d+\s()+-]{10,20}/g;
    const parts: string[] = [];
    let last = 0;

    for (const match of caption.matchAll(tokenRegex)) {
        const raw = match[0].replace(/\s+$/, '');
        const digits = raw.replace(/\D/g, '');
        if (digits.length < 10 || digits.length > 15) continue;

        const start = match.index!;
        const end = start + raw.length;

        const before = caption.slice(last, start);
        if (before) parts.push(applyFormatting(escapeHtml(before)));

        const name = resolveDisplayName(digits);
        const displayName = name ? `@${name}` : `@${digits}`;
        // Nome do contato é conteúdo dele (push name): escapa antes de entrar no HTML.
        parts.push(`<span class="mention-highlight" data-phone="${digits}">${escapeHtml(displayName)}</span>`);

        last = end;
    }

    const tail = caption.slice(last);
    if (tail) parts.push(applyFormatting(escapeHtml(tail)));

    return parts.length ? parts.join('') : applyFormatting(escapeHtml(caption));
}

function handleCaptionClick(event: MouseEvent) {
    const span = (event.target as HTMLElement).closest('.mention-highlight') as HTMLElement | null;
    if (span?.dataset.phone) {
        chatStore.handleClickOnTextWithAction('phone', span.dataset.phone);
    }
}

async function downloadFile(url?: string, fileName?: string) {
    if (!url) return;

    try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Falha na rede ao baixar arquivo');

        const blob = await response.blob();
        const blobUrl = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', fileName || 'documento');

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);

    } catch (error) {
        console.error('Erro ao tentar baixar o arquivo:', error);
    }
}

function openImageModal(): void {
    // Ainda carregando: não há o que abrir no visualizador.
    if (!props.message.fileData?.url) return;
    if ((props.message.type === 'file' || props.message.type === 'imagem') && props.message?.fileData?.mimeType.startsWith('image/')) {
        uiStore.openMediaViewer(
            props.message.fileData.url,
            'image',
            props.message.fileData.caption
        );
    }
}

function openDocument(url?: string): void {
    if (url) {
        window.open(url, '_blank');
    }
}
</script>
<style scoped>
.media-carregando {
    position: relative;
    min-width: 220px;
    min-height: 140px;
    max-width: 280px;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 0.25rem;
    background: var(--bs-secondary-bg, rgba(0, 0, 0, 0.08));
}
.media-carregando__miniatura {
    width: 100%;
    height: 100%;
    min-height: 140px;
    object-fit: cover;
    filter: blur(2px);
}
.media-carregando__aviso {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 0.85rem;
    color: var(--bs-body-color, #333);
    background: rgba(255, 255, 255, 0.45);
}
.media-load-failed {
    min-height: 120px;
    width: 100%;
    padding: 16px;
    border: 1px dashed rgba(0, 0, 0, 0.15);
    border-radius: 6px;
    gap: 4px;
}

.quoted-reply-wrapper {
    display: flex;
    flex-grow: 1;
    /* min-height: 65px;
    cursor: pointer;
    padding: 8px 12px;
    border-left: 3px solid #4a90e2;
    background-color: rgba(74, 144, 226, 0.1);
    border-radius: 4px;
    margin-bottom: 8px;
    transition: background-color 0.2s ease; */
}

.quoted-reply-wrapper:hover {
    background-color: rgba(74, 144, 226, 0.15);
}

.quoted-content {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

/* .quoted-owner {
    font-weight: 600;
    font-size: 0.85rem;
    color: #4a90e2;
} */

/* .quoted-snippet {
    font-size: 0.9rem;
    color: #666;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} */

.reply-media-preview {
    display: flex;
    align-items: center;
    gap: 8px;
    /* color: #666; */
    font-size: 0.9rem;
}

.please-match-with-your-sibling {
    height: 65px;
    border-radius: 8px 0 0 8px !important;
}

.reply-media-content-preview {
    /* max-width: 80px; */
    height: 65px;
    border-radius: 0 8px 8px 0;
}

.reply-media-preview i {
    font-size: 1.1rem;
}

li.msg_wpp_render {
    margin-bottom: 16px;
    display: flex;
    position: relative;
    width: 100%;
    padding-right: 20px !important;
}

li.msg_wpp_render.received-message,
li.msg_wpp_render.system-message {
    justify-content: flex-start;
}

li.msg_wpp_render.right {
    justify-content: flex-end;
}

.conversation-list {
    transition: transform 0.3s ease;
    transform: translateX(0);
}

.ctext-wrap {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    position: relative;
}

li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content {
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 550px;
    padding: 10px;
    border-radius: 12px;
    position: relative;
    border: none;

    display: inline-block;

    text-align: left;
}

.message-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    font-size: 14.5px;
    line-height: 1.5;
    white-space: pre-wrap;
}

.chat-time {
    font-size: 11px !important;
    opacity: 0.7;
    margin-top: 8px;
    text-align: right;
    color: var(--bs-text-muted);
}

.ack i {
    font-size: 16px;
    /* color: var(--bs-text-muted); */
}

.status-read {
    color: #00ffbd !important;
}


li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content::before {
    content: "";
    position: absolute;
    bottom: -9px;
}


[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content {
    background: var(--bs-white, #fff) !important;
    color: var(--bs-body-color) !important;
    border-radius: 12px 12px 12px 0;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content::before {
    border-top-color: var(--bs-white, #fff) !important;
    border-left-color: var(--bs-white, #fff) !important;
    left: 0;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 0 12px;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-end) !important; /* Ponta pega a cor final do gradiente */
    border-right-color: var(--brand-bubble-gradient-end) !important;
    right: 0;
    left: auto;
}
[data-bs-theme=light] li.msg_wpp_render.system-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-start) !important;
    border-left-color: var(--brand-bubble-gradient-start) !important;
    left: 0;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.received-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .pinned-icon,
[data-bs-theme=light] li.msg_wpp_render.system-message .chat-time {
    color: rgba(255, 255, 255, 0.9) !important;
}


[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content {
    background: var(--bs-light) !important;
    color: var(--bs-dark) !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #fff !important;
    text-decoration: underline;
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content::before {
    border-top-color: var(--bs-light) !important;
    border-left-color: var(--bs-light) !important;
    left: 0;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 0 12px;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-end) !important;
    border-right-color: var(--brand-bubble-gradient-end) !important;
    right: 0;
    left: auto;
}

[data-bs-theme=dark] li.msg_wpp_render.system-message .ctext-wrap-content {
    background: var(--brand-gradient-bubble-sent) !important;
    color: #fff !important;
    border-radius: 12px 12px 12px 0;
}

[data-bs-theme=dark] li.msg_wpp_render.system-message .ctext-wrap-content::before {
    border-top-color: var(--brand-bubble-gradient-start) !important;
    border-left-color: var(--brand-bubble-gradient-start) !important;
    left: 0;
}


/* ── Emoji hover bar (estilo WhatsApp) ── */
.emoji-hover-bar {
    position: absolute;
    bottom: calc(100% + 4px);
    z-index: 200;
    display: flex;
    gap: 2px;
    align-items: center;
    background: var(--bs-body-bg);
    border: 1px solid var(--bs-border-color);
    border-radius: 24px;
    padding: 4px 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
    white-space: nowrap;
}

li.msg_wpp_render.right .emoji-hover-bar {
    right: 36px;
}

li.msg_wpp_render:not(.right) .emoji-hover-bar {
    left: 0;
}

.emoji-quick-btn {
    background: none;
    border: none;
    padding: 3px 5px;
    font-size: 20px;
    line-height: 1;
    border-radius: 50%;
    cursor: pointer;
    transition: transform 0.15s ease, background 0.15s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.emoji-quick-btn:hover {
    transform: scale(1.35) translateY(-2px);
    background: var(--bs-secondary-bg);
}

/* Transition */
.emoji-bar-enter-active,
.emoji-bar-leave-active {
    transition: opacity 0.15s ease, transform 0.15s ease;
}
.emoji-bar-enter-from,
.emoji-bar-leave-to {
    opacity: 0;
    transform: translateY(4px);
}

.emoji-more-btn {
    border-left: 1px solid var(--bs-border-color);
    margin-left: 2px;
    padding-left: 8px;
    color: var(--bs-text-muted);
}

.emoji-more-btn:hover {
    color: var(--bs-body-color);
}

.emoji-picker-wrapper {
    position: absolute;
    bottom: calc(100% + 8px);
    z-index: 300;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.18);
    border-radius: 12px;
    overflow: hidden;
}

li.msg_wpp_render.right .emoji-picker-wrapper {
    right: 0;
}

li.msg_wpp_render:not(.right) .emoji-picker-wrapper {
    left: 0;
}

.bot-list-button {
    font-weight: 500;
    border-radius: 6px;
    padding: 10px 12px;
    text-align: center;
    cursor: pointer;
    transition: background-color 0.2s ease;
    background: var(--bs-green);
    color: white;
    box-shadow: var(--bs-box-shadow);
}
.bot-list-button:hover {
    background-color: var(--brand-success-hover);
    box-shadow: 0 0.125rem 1rem 0px rgb(0 0 0 / 25%);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .ack i,
[data-bs-theme=dark] li.msg_wpp_render.system-message .chat-time {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .status-read {
    color: #75cffc !important;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .chat-time {
    color: #ffc4dc !important;
}



.audio-meta-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 4px;
    padding: 0 4px 0 2px;
}

.audio-meta-row .chat-time-stamp {
    font-size: 11px !important;
    opacity: 0.7;
    color: var(--bs-text-muted);
}

.audio-meta-row .ack i {
    font-size: 16px;
    /* color: var(--bs-text-muted); */
}

.audio-meta-row .status-read {
    color: #50a5f1 !important;
}

.btn-download-audio {
    /* color: var(--bs-text-muted); */
    opacity: 0.7;
    padding: 0;
    font-size: 16px;
    line-height: 1;
    text-decoration: none !important;
    box-shadow: none !important;
}

.btn-download-audio:hover {
    opacity: 1;
    color: var(--bs-dark);
}

[data-bs-theme=dark] .audio-meta-row .chat-time-stamp,
[data-bs-theme=dark] .btn-download-audio {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] .btn-download-audio:hover {
    color: #fff;
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .ack i {
    color: rgba(255, 255, 255, 0.7);
}

[data-bs-theme=dark] li.msg_wpp_render.sent-message .audio-meta-row .status-read {
    color: #75cffc !important;
}

[data-bs-theme=light] li.msg_wpp_render.sent-message .audio-meta-row .status-read {
    color: #50a5f1 !important;
}

[data-bs-theme=light] li.msg_wpp_render.system-message .audio-meta-row .chat-time-stamp {
    color: #ffc4dc !important;
}


.ctext-wrap .dropdown {
    flex-shrink: 0;
    margin-top: 2px;
}

.ctext-wrap .dropdown-toggle {
    text-decoration: none !important;
    box-shadow: none !important;
    padding: 0;
    font-size: 1.1rem;
    color: var(--bs-text-muted);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
}

.conversation-list:hover .dropdown-toggle {
    opacity: 1;
}

.ctext-wrap .dropdown-toggle::after {
    display: none;
}

.ctext-wrap .dropdown-toggle:hover {
    background-color: rgba(0, 0, 0, 0.05);
}

[data-bs-theme=dark] .ctext-wrap .dropdown-toggle:hover {
    background-color: rgba(255, 255, 255, 0.05);
}

[data-bs-theme=dark] .sent-message .dropdown-toggle {
    color: var(--bs-dark);
}

[data-bs-theme=dark] .sent-message .dropdown-toggle:hover {
    background-color: rgba(0, 0, 0, 0.1);
}

.quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 8px 12px;
    margin-bottom: 8px;
    cursor: pointer;
    opacity: 0.9;
    border-left: 4px solid var(--bs-success);
    overflow: hidden;

    max-width: 100%;
}

.quoted-owner {
    font-weight: 600;
    color: var(--bs-primary);
    font-size: 13px;
}

.quoted-snippet {
    font-size: 14px;
    color: var(--bs-text-muted);

    white-space: normal;

    word-break: break-word;

    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    line-clamp: 2;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

[data-bs-theme=dark] .quoted-reply-wrapper {
    background-color: rgba(255, 255, 255, 0.05);
    border-left: 4px solid var(--bs-success);
}

[data-bs-theme=dark] .quoted-owner {
    color: var(--bs-primary);
}

[data-bs-theme=dark] .quoted-snippet {
    color: rgba(255, 255, 255, 0.7);
}


li.msg_wpp_render.received-message .quoted-reply-wrapper {
    border-left: 4px solid var(--bs-success);
}

li.msg_wpp_render.received-message .quoted-snippet {
    opacity: 0.9; 
}

li.msg_wpp_render.received-message .quoted-owner {
    color: var(--bs-white-text, #ffffff); /* Fallback para branco caso a var não exista */
}

.sent-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-left: 4px solid var(--bs-success);
}

.sent-message .quoted-owner {
    color: var(--bs-primary);
}

.sent-message .quoted-snippet {
    color: var(--bs-text-muted);
}

[data-bs-theme=dark] .sent-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid var(--bs-success);
}

[data-bs-theme=dark] .sent-message .quoted-owner {
    color: var(--bs-primary);
}

[data-bs-theme=dark] .sent-message .quoted-snippet {
    color: var(--bs-text-muted);
}


.reaction-picker-popper {
    background: var(--bs-light);
    border-radius: 20px;
    padding: 4px 8px;
    display: flex;
    gap: 4px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

.reaction-picker-popper .emoji-btn {
    font-size: 22px;
    padding: 4px;
    border: none;
    background: transparent;
    border-radius: 8px;
    transition: transform 0.1s ease, background-color 0.15s ease;
}

.reaction-picker-popper .emoji-btn:hover {
    transform: scale(1.15);
    background-color: var(--bs-light-bg-subtle);
}

.reactions-wrapper {
    background-color: var(--bs-light);
    color: var(--bs-dark);
    border: 1px solid var(--bs-border-color);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    position: absolute;
    bottom: -10px;
    right: 12px;
    z-index: 2;
    display: flex;
}

.sent-message .reactions-wrapper {
    right: auto;
    left: 12px;
}

.reaction-item {
    padding: 1px 5px;
    font-size: 13px;
    cursor: pointer;
    transition: transform 0.1s ease;
}

.reaction-item:hover {
    transform: scale(1.1);
}

.reaction-item+.reaction-item {
    margin-left: -5px;
}


.chat-time {
    position: relative;
    z-index: 1;
}

.edited-badge {
    font-size: 10px;
    font-style: italic;
    opacity: 0.8;
    margin-right: 4px;
}


li.msg_wpp_render {
    transition: background-color 0.2s ease-in-out, padding-left 0.3s ease;
    border-radius: 8px;
    padding-left: 0px;
}

.conversation-list.forward-mode {
    cursor: pointer;
}

li.msg_wpp_render:has(.conversation-list.forward-mode) {
    padding: 0rem 2rem;
}

.conversation-list.forward-mode .ctext-wrap {
    transform: translateX(0);
}

li.msg_wpp_render:has(.conversation-list.forward-mode):hover {
    background-color: #6ae6c711;
    cursor: pointer;
}

li.msg_wpp_render:has(.conversation-list.forward-mode .form-check-input:checked) {
    background-color: #6ae6c720;
    cursor: pointer;
}

li.msg_wpp_render.reply-selected {
    background-color: #6ae6c720;
    transition: background-color 0.2s ease;
}

.message-selection-box {
    flex-shrink: 0;
    padding: 0 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
}

.message-selection-box .form-check {
    padding: 0;
}

.message-selection-box .form-check-input {
    font-size: 1.25rem;
    pointer-events: none;
}

.message-selection-box .form-check-input {
    font-size: 1.25rem;
    pointer-events: none;
    border-radius: 6px;
    background-color: transparent;
    border: 2px solid var(--bs-text-muted);
    box-shadow: none !important;
    background-image: none !important;
}

.message-selection-box .form-check-input:focus {
    border-color: var(--bs-primary);
    box-shadow: none;
}

.message-selection-box .form-check-input:checked {
    background-color: var(--bs-primary);
    border-color: var(--bs-primary) !important;

    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");

    background-image: var(--bs-form-check-bg-image) !important;
}


.dropdown-item-v.copied-feedback {
    color: var(--bs-success);
    font-weight: 500;
}

.dropdown-item-v.copied-feedback i {
    color: var(--bs-success) !important;
}

.favorite-star-icon {
    font-size: 11px;
    margin-right: 4px;
    vertical-align: middle;
    opacity: 0.9;
}

.received-message .favorite-star-icon,
.system-message .favorite-star-icon {
    color: #fff;
    opacity: 1;
}

.pinned-icon {
    font-size: 11px;
    vertical-align: middle;
    color: var(--bs-text-muted);
}

.received-message .pinned-icon,
.system-message .pinned-icon {
    color: #fff;
    opacity: 0.8;
}

[data-bs-theme=dark] .sent-message .pinned-icon {
    color: var(--bs-text-muted);
}

.system-message-wrapper {
    display: flex;
    justify-content: center;
    margin: 1rem 0;
}

.system-message-text {
    background-color: var(--bs-light-bg-subtle);
    color: var(--bs-text-muted);
    font-size: 13px;
    font-weight: 500;
    padding: 6px 12px;
    border-radius: 6px;
}



.file-message-card {
    background-color: rgba(0, 0, 0, 0.05);
    border-radius: 8px;
    padding: 4px;
    margin-bottom: 2px;
    max-width: 300px;
}

[data-bs-theme="dark"] .file-message-card {
    background-color: rgba(255, 255, 255, 0.08);
}

.file-card-inner {
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
}

[data-bs-theme="dark"] .file-card-inner {
    background-color: #2a2d31;
}

.file-icon {
    font-size: 28px;
    color: #ff5e5e;
    margin-right: 10px;
}

.file-info {
    display: flex;
    flex-direction: column;
    overflow: hidden;
    flex-grow: 1;
}

.file-name {
    font-size: 14px;
    font-weight: 500;
    color: var(--bs-body-color);
}

.file-meta {
    font-size: 11px;
    color: var(--bs-text-muted);
}

.btn-download-file {
    color: var(--bs-text-muted);
    border: 1px solid var(--bs-border-color);
    border-radius: 50%;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;

    background: transparent;
    padding: 0;
    cursor: pointer;
    transition: all 0.2s;
}

.btn-download-file:hover {
    background-color: rgba(0,0,0,0.05);
    color: var(--bs-primary);
    border-color: var(--bs-primary);
}

.contact-message-card {
    width: 280px;
    background-color: rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    overflow: hidden;
    box-shadow: var(--bs-box-shadow);
}

[data-bs-theme="dark"] .contact-message-card {
    background-color: rgba(255, 255, 255, 0.05);
}

.contact-header {
    display: flex;
    align-items: center;
    padding: 12px;
    gap: 12px;
}

.avatar-contact {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-color: #ced4da;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 600;
}

.contact-name {
    font-size: 15px;
    font-weight: 500;
    color: var(--bs-body-color);
}

.contact-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    padding: 8px;
    text-align: center;
    box-shadow: var(--bs-box-shadow-lg);
}

[data-bs-theme="dark"] .contact-footer {
    border-top-color: rgba(255, 255, 255, 0.1);
}

.btn-contact-action {
    color: var(--bs-success);
    font-weight: 500;
    text-decoration: none;
    width: 100%;
    font-size: 14px;
    border-radius: 1rem;
}

.btn-contact-action:hover {
    color: #04956f;
}

.rounded {
    border-radius: 12px !important;
}

.cursor-pointer {
    cursor: pointer;
}

.agent-name-header {
    font-size: 12.5px;
    font-weight: 700;
    color: var(--bs-primary);
    margin-bottom: 2px;
    display: block;
    line-height: 1.2;
    opacity: 0.9;
}

li.msg_wpp_render.received-message .agent-name-header {
    color: #ffffff !important;
    opacity: 1;
}

[data-bs-theme=dark] .agent-name-header {
    color: var(--brand-name-accent);
}

.message-text.pt-1 {
    padding-top: 4px !important;
}

:deep(.search-highlight) {
    background-color: rgba(var(--bs-success-rgb), 0.47);
    padding: 0 1px;
    border-radius: 3px;
    font-weight: 500;
}

:deep(.chat-link) {
    color: #027eb5;
    text-decoration: underline;
    word-break: break-all;
}

:deep(.chat-link:hover) {
    color: #027eb5;
}


:deep(.chat-code) {
    font-family: monospace;
    background-color: rgba(0, 0, 0, 0.1);
    padding: 2px 4px;
    border-radius: 4px;
    font-size: 0.9em;
}


.template-card {
    min-width: 260px;
    max-width: 320px;
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 5px;
    position: relative;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.pix-style {
    background-color: #fff;
    border: 1px solid #e0f2f1;
}

.card-header-accent {
    height: 6px;
    background: linear-gradient(90deg, #32bcad, #26a69a);
    width: 100%;
}

.card-body-content {
    padding: 16px;
}

.pix-title-row {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
}

.pix-icon-brand {
    color: #32bcad;
    font-size: 20px;
}

.pix-label {
    font-weight: 700;
    color: #333;
    font-size: 15px;
    letter-spacing: -0.3px;
}

.detail-group {
    margin-bottom: 12px;
}

.detail-group label {
    font-size: 10px;
    text-transform: uppercase;
    color: #999;
    font-weight: 700;
    letter-spacing: 0.5px;
    display: block;
    margin-bottom: 2px;
}

.detail-group p {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin: 0;
}

.key-container {
    background: #f4f6f8;
    border-radius: 6px;
    padding: 6px 10px;
    border: 1px solid #eee;
}

.key-text {
    font-family: monospace;
    font-size: 13px;
    color: #555;
    display: block;
}

.btn-action-pix {
    width: 100%;
    background-color: #e0f2f1;
    color: #00897b;
    border: none;
    padding: 10px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.btn-action-pix:hover {
    background-color: #b2dfdb;
}

/* === ESTILO SENHA === */
.pass-style {
    background-color: #fff;
    padding: 24px 20px;
    text-align: center;
    border: 1px solid #eee;
}

.pass-icon-circle {
    width: 48px;
    height: 48px;
    background-color: #e8eaf6;
    color: #3f51b5;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    margin: 0 auto 12px auto;
}

.pass-title {
    font-weight: 700;
    color: #333;
    margin: 0;
    font-size: 16px;
}

.pass-desc {
    font-size: 12px;
    color: #888;
    margin-bottom: 16px;
    line-height: 1.4;
}

.code-display {
    background: #f8f9fa;
    border: 2px dashed #c5cae9;
    border-radius: 8px;
    padding: 12px;
    font-size: 20px;
    font-weight: 800;
    letter-spacing: 3px;
    color: #333;
    position: relative;
    cursor: pointer;
    transition: all 0.2s;
}

.code-display:hover {
    background: #e8eaf6;
    border-color: #3f51b5;
}

.copy-icon {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 14px;
    color: #999;
    opacity: 0;
    transition: opacity 0.2s;
}

.code-display:hover .copy-icon {
    opacity: 1;
}

.pass-footer {
    margin-top: 16px;
    font-size: 10px;
    color: #aaa;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* === DARK MODE ADJUSTMENTS === */
[data-bs-theme=dark] .pix-style,
[data-bs-theme=dark] .pass-style {
    background-color: #2a2d31;
    border-color: #3a3f44;
}

[data-bs-theme=dark] .pix-label,
[data-bs-theme=dark] .pass-title,
[data-bs-theme=dark] .detail-group p {
    color: #e9ecef;
}

[data-bs-theme=dark] .key-container {
    background-color: #32363a;
    border-color: #3a3f44;
}

[data-bs-theme=dark] .key-text {
    color: #adb5bd;
}

[data-bs-theme=dark] .btn-action-pix {
    background-color: rgba(50, 188, 173, 0.15);
    color: #32bcad;
}

[data-bs-theme=dark] .code-display {
    background-color: #32363a;
    border-color: #3f51b5;
    color: #fff;
}

[data-bs-theme=dark] .pass-icon-circle {
    background-color: rgba(63, 81, 181, 0.2);
}

.group-sender-name {
    font-size: 13px;
    font-weight: 700;
    color: #ffffff;
    line-height: 1.2;
}

[data-bs-theme=dark] .group-sender-name {
    color: var(--brand-name-accent);
}

.sticker {
    max-width: 200px;
}

.file-preview {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
}

.file-link {
    color: #007bff;
    text-decoration: none;
    display: flex;
    align-items: center;
}

.file-link i {
    margin-right: 5px;
}

.file-caption {
    font-size: 0.9em;
    color: #6c757d;
    margin-top: 5px;
}

.location-message-card {
    width: 300px;
    background-color: rgba(0,0,0,0.03);
    border-radius: 12px;
    overflow: hidden;
    margin-bottom: 2px;
    border: 1px solid rgba(0,0,0,0.05);
}

.location-preview {
    position: relative;
    height: 180px;
    width: 100%;
}

.location-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 10;
    cursor: pointer;
}

.location-footer {
    padding: 10px 12px;
    background-color: rgba(255,255,255,0.6);
    cursor: pointer;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: var(--bs-body-color);
    font-weight: 500;
}

/* Dark Mode Location */
[data-bs-theme="dark"] .location-message-card {
    background-color: rgba(255,255,255,0.05);
    border-color: rgba(255,255,255,0.1);
}
[data-bs-theme="dark"] .location-footer {
    background-color: #2a2d31;
    color: #e9ecef;
}


/* === ENQUETE (POLL) === */
.poll-message-card {
    min-width: 280px;
    max-width: 350px;
    padding: 12px;
    background-color: rgb(255 255 255 / 22%);
    border-radius: 12px;
}

.poll-question {
    font-weight: 700;
    font-size: 15px;
    margin-bottom: 4px;
    color: var(--bs-heading-color);
}

.poll-subtitle {
    font-size: 11px;
    display: block;
    margin-bottom: 12px;
}

.poll-options-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.poll-option-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-bottom: 4px;
}

.poll-checkbox {
    font-size: 20px;
    color: var(--bs-text-muted);
    opacity: 0.7;
}

.poll-bar-container {
    flex-grow: 1;
}

.poll-label-row {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    font-weight: 500;
}

.poll-footer-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    border-top: 1px solid rgb(221 221 221 / 52%);
}

.btn-vote-action {
    border-radius: 20px;
    padding: 4px 16px;
    font-size: 12px;
    font-weight: 600;
    background-color: transparent;
    border: 1px solid var(--bs-success);
    color: var(--bs-success);
}

.vote-count-text {
    font-size: 11px;
    cursor: pointer;
}

[data-bs-theme="dark"] .poll-message-card {
    background-color: rgba(255,255,255,0.05);
}
[data-bs-theme="dark"] .poll-question {
    color: #fff;
}
[data-bs-theme="dark"] .poll-footer-info {
    border-top-color: rgba(255,255,255,0.1);
}


/* === CARD DE MÚLTIPLOS CONTATOS (PREMIUM STYLE) === */
.multi-contact-card {
    background: #ffffff;
    border-radius: 18px; /* Mais arredondado = mais moderno */
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08); /* Sombra mais difusa */
    border: 1px solid rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    margin-bottom: 2px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.multi-contact-card:hover {
    box-shadow: 0 6px 16px rgba(0,0,0,0.12);
}

/* --- CORPO (Avatares + Texto) --- */
.multi-contact-body {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #fff;
}

/* Área dos Avatares */
.avatars-area {
    flex-shrink: 0;
}

.avatar-stack-wrapper {
    display: flex;
    align-items: center;
    padding-left: 8px; /* Espaço para o primeiro avatar não cortar */
}

.stack-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid #fff; /* Borda branca grossa para separar visualmente */
    overflow: hidden;
    background-color: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.05);
    margin-left: -14px; /* Sobreposição agressiva */
    position: relative;
    transition: transform 0.2s ease;
}

/* Efeito hover sutil nos avatares */
.multi-contact-card:hover .stack-avatar:nth-child(1) { transform: translateX(0); }
.multi-contact-card:hover .stack-avatar:nth-child(2) { transform: translateX(2px); }
.multi-contact-card:hover .stack-avatar:nth-child(3) { transform: translateX(4px); }
.multi-contact-card:hover .stack-avatar.counter { transform: translateX(6px); }

.stack-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

/* Iniciais e Contador */
.stack-avatar.initials,
.stack-avatar.counter {
    font-size: 13px;
    font-weight: 700;
    color: #5e6c84;
    letter-spacing: -0.5px;
}

.stack-avatar.counter {
    background-color: #e2e8f0;
    color: #475569;
    z-index: 0;
}

/* Estilo para avatar com gradiente fallback */
.stack-avatar:not(.has-image):not(.counter) {
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%);
    color: #0284c7;
}

/* --- TEXTOS --- */
.contact-info-col {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    overflow: hidden;
}

.primary-name {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b; /* Cinza bem escuro, quase preto */
    margin: 0;
    line-height: 1.2;
}

.secondary-text {
    font-size: 12px;
    color: #64748b; /* Slate 500 */
    margin-top: 2px;
    font-weight: 500;
}

/* --- RODAPÉ (BOTÃO) --- */
.multi-contact-footer {
    background-color: #f8fafc; /* Fundo levemente cinza */
    border-top: 1px solid #f1f5f9;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.2s;
}

.multi-contact-footer:hover {
    background-color: #f1f5f9;
}

.btn-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-primary); /* Usa cor do tema */
}

.arrow-icon {
    font-size: 16px;
    color: var(--bs-primary);
    opacity: 0.7;
    transition: transform 0.2s;
}

.multi-contact-footer:hover .arrow-icon {
    transform: translateX(3px);
    opacity: 1;
}

/* === DARK MODE === */
[data-bs-theme="dark"] .multi-contact-card {
    background: #1e293b; /* Slate 800 */
    border-color: rgba(255,255,255,0.05);
}

[data-bs-theme="dark"] .multi-contact-body,
[data-bs-theme="dark"] .multi-contact-footer {
    background-color: transparent;
}

[data-bs-theme="dark"] .multi-contact-footer {
    background-color: rgba(0,0,0,0.15);
    border-top-color: rgba(255,255,255,0.08);
}

[data-bs-theme="dark"] .stack-avatar {
    border-color: #1e293b;
    background-color: #334155;
}

[data-bs-theme="dark"] .stack-avatar.initials,
[data-bs-theme="dark"] .stack-avatar.counter {
    color: #cbd5e1;
    background-color: #334155;
}

[data-bs-theme="dark"] .stack-avatar:not(.has-image):not(.counter) {
    background: linear-gradient(135deg, #334155 0%, #475569 100%);
    color: #e2e8f0;
}

[data-bs-theme="dark"] .primary-name { color: #f1f5f9; }
[data-bs-theme="dark"] .secondary-text { color: #94a3b8; }

/* === CARD DE CONTATO ÚNICO (PREMIUM STYLE) === */
.contact-card-premium {
    background: #ffffff;
    border-radius: 18px;
    overflow: hidden;
    min-width: 250px;
    max-width: 290px;
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    border: 1px solid rgba(0,0,0,0.06);
    display: flex;
    flex-direction: column;
    margin-bottom: 2px;
    transition: transform 0.2s ease, box-shadow 0.2s ease;

    /* Importante: Reseta cores herdadas do balão */
    color: initial;
}

.contact-card-premium:hover {
    box-shadow: 0 6px 16px rgba(0,0,0,0.12);
    transform: translateY(-1px);
}

/* --- ÁREA COMUM (CORPO) --- */
.premium-card-body {
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 14px;
    background-color: #fff;
}

/* Avatar Único (Maior que o da pilha) */
.single-avatar {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    overflow: hidden;
    background: linear-gradient(135deg, #e0f2fe 0%, #bae6fd 100%); /* Azul suave default */
    display: flex;
    align-items: center;
    justify-content: center;
    color: #0284c7;
    border: 1px solid rgba(0,0,0,0.04);
    flex-shrink: 0;
}

.single-avatar .initials {
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.5px;
}

/* Tipografia (Reutilizando classes do Multi, mas garantindo especificidade) */
.contact-card-premium .primary-name {
    font-size: 15px;
    font-weight: 700;
    color: #1e293b;
    margin: 0;
    line-height: 1.2;
}

.contact-card-premium .secondary-text {
    font-size: 13px; /* Ligeiramente maior para número de telefone */
    color: #64748b;
    margin-top: 3px;
    font-weight: 500;
    display: block;
}

/* --- RODAPÉ (FOOTER) --- */
.premium-card-footer {
    background-color: #f8fafc;
    border-top: 1px solid #f1f5f9;
    padding: 12px 16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
    transition: background-color 0.2s;
}

.premium-card-footer:hover {
    background-color: #f1f5f9;
}

.premium-card-footer .btn-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--bs-primary);
}

.premium-card-footer .action-icon {
    font-size: 16px;
    color: var(--bs-primary);
    opacity: 0.8;
    transition: transform 0.2s;
}

.premium-card-footer:hover .action-icon {
    transform: scale(1.1);
    opacity: 1;
}

/* === DARK MODE === */
[data-bs-theme="dark"] .contact-card-premium {
    background: #1e293b; /* Slate 800 */
    border-color: rgba(255,255,255,0.05);
}

[data-bs-theme="dark"] .premium-card-body,
[data-bs-theme="dark"] .premium-card-footer {
    background-color: transparent;
}

[data-bs-theme="dark"] .premium-card-footer {
    background-color: rgba(0,0,0,0.15);
    border-top-color: rgba(255,255,255,0.08);
}

[data-bs-theme="dark"] .single-avatar {
    background: linear-gradient(135deg, #334155 0%, #475569 100%);
    color: #e2e8f0;
    border-color: rgba(255,255,255,0.1);
}

[data-bs-theme="dark"] .contact-card-premium .primary-name { color: #f1f5f9; }
[data-bs-theme="dark"] .contact-card-premium .secondary-text { color: #94a3b8; }

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content {
    background: #f8f9fa91 !important;
    background-image: none !important;
    border: 1px solid #e9ecef !important;
    border-left: 4px solid #b0b0b0 !important;
    color: #495057 !important;
    font-style: italic !important;
}
li.msg_wpp_render.received-message .deleted-notice {
    font-weight: 600;
    font-size: 12px;
    text-transform: none;
    border-bottom: 1px solid rgba(0,0,0,0.05);
    margin-bottom: 6px;
    padding-bottom: 6px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.ctext-wrap-content.deleted-content {
    font-style: italic !important;
}
.deleted-content {
    background-image: none !important;
    background-color: #f8f9fa91 !important;
    background: linear-gradient(to bottom, #ffffff47, #fafafa) !important;

    border: 1px solid rgba(0,0,0,0.06) !important;
    border-left: 4px solid #b0b0b0 !important;

    box-shadow: 0 2px 4px rgba(0,0,0,0.03) !important;
    color: #6c757d !important;

    transition: all 0.3s ease;
    overflow: hidden;
}

.deleted-notice {
    font-size: 12px;
    font-weight: 600;
    color: #878a8c;
    text-transform: none;
    letter-spacing: normal;

    margin-bottom: 8px;
    padding-bottom: 6px;
    border-bottom: 1px solid rgba(0,0,0,0.05);

    display: flex;
    align-items: center;
    gap: 6px;
}

.deleted-notice i {
    font-size: 14px;
    color: #999;
}

.deleted-content:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08) !important;
    border-left-color: #999 !important;
    background-color: #fff !important;
}

.opacity-50 {
    opacity: 0.6;
    filter: grayscale(100%);
    transition: all 0.3s ease;
}

.deleted-content:hover .opacity-50 {
    opacity: 0.85;
    filter: grayscale(0%);
}

[data-bs-theme=dark] .deleted-content {
    background: #222529 !important; /* Fundo escuro sólido */
    border-color: rgba(255,255,255,0.05) !important;
    border-left-color: #4a4a4a !important;
    color: #adb5bd !important;
}

[data-bs-theme=dark] .deleted-notice {
    color: #888;
    border-bottom-color: rgba(255,255,255,0.08);
}

li.msg_wpp_render.received-message .deleted-notice i {
    font-size: 14px !important;
    color: #adb5bd !important;
}

.deleted-content .opacity-50 {
    opacity: 0.5;
    filter: grayscale(100%);
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content {
    background: var(--bs-light) !important;
    background-image: none !important;
    border: 1px solid rgba(255,255,255,0.05) !important;
    border-left: 4px solid #4a4a4a !important;
    color: #ced4da !important;
}

[data-bs-theme=dark] li.msg_wpp_render.received-message .deleted-notice {
    color: #adb5bd !important;
    border-bottom-color: rgba(255,255,255,0.1);
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .chat-time span,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .align-middle {
    color: var(--bs-secondary-color);
    font-style: italic;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .pinned-icon {
    color: #6c757d !important;
}


.image-message {
    height: auto;
    position: relative;
    width: 350px;
    max-width: 100%;
    display: flex;
    flex-direction: column;
}

.image-message.sticker-wrapper {
    width: auto !important;
    background-color: transparent !important;
}

.chat-media-fixed {
    height: 350px;
    width: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: 8px !important;
    min-height: 100px;
    background-color: #f0f2f5; /* Cor de fundo cinza claro enquanto carrega (placeholder) */
    transition: opacity 0.3s ease-in;
}

img[loading="lazy"] {
    display: block; /* Garante que o navegador respeite as dimensões de bloco */
}

.message-text.pt-1 {
    padding: 8px 4px 4px 4px !important;
    width: 100%;
    box-sizing: border-box;
}

.chat-media-fixed.sticker {
    height: 160px !important;
    width: 160px !important;
    object-fit: contain !important;
    background-color: transparent !important;
    box-shadow: none !important;
}

.image-message:hover .chat-media-fixed:not(.sticker) {
    opacity: 0.95;
    transition: opacity 0.2s ease;
}

/* Adicione isso ao final do seu style */

:deep(.mention-highlight) {
    color: var(--bs-success);
    font-weight: 600;
    cursor: pointer;
    text-decoration: none;
    transition: opacity 0.2s;
}

:deep(.mention-highlight:hover) {
    opacity: 0.8;
    text-decoration: underline;
}

[data-bs-theme="dark"] :deep(.mention-highlight) {
    color: var(--bs-success);
}

.group-chat-avatar-container {
    display: flex;
    align-items: flex-end;
    margin-right: 8px;
    padding-bottom: 2px;
    z-index: 1;
}

.group-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;

    border-width: 2px; /* pra borda */
    border-style: solid; /* pra borda */

    background: var(--bs-sidebar-bg);
    padding: 1px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}

/* .group-avatar-img {
    width: 32px;
    height: 32px;
    object-fit: cover;
    border: 1px solid rgba(0,0,0,0.05);
    background-color: #fff;
} */

li.msg_wpp_render.received-message {
    align-items: flex-end;
}

.text-line-clamp {
    display: -webkit-box;
    -webkit-line-clamp: 10;
    line-clamp: 10;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
}

.btn-read-more {
    background: transparent;
    border: none;
    color: #027eb5;
    font-size: 13px;
    font-weight: 600;
    padding: 4px 0 0 0;
    cursor: pointer;
    display: block;
    width: 100%;
    text-align: left;
    transition: opacity 0.2s;
    pointer-events: all;
}

.btn-read-more:hover {
    opacity: 0.8;
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .btn-read-more {
    color: #fff;
    text-shadow: 0 1px 1px rgba(0,0,0,0.1);
}

[data-bs-theme="light"] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #84ffdf !important; /* Cor solicitada para alto contraste no gradiente */
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message :deep(.chat-link:hover) {
    color: #ffffff !important;
}

[data-bs-theme="dark"] li.msg_wpp_render.received-message :deep(.chat-link) {
    color: #68b8ff !important; /* Cor azul claro solicitada */
    text-decoration: underline;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name {
    color: var(--bs-primary) !important; /* Cor da marca, para contraste no fundo cinza */
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content :deep(.chat-link) {
    color: #027eb5 !important;
}

[data-bs-theme="light"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name i {
    color: var(--bs-primary) !important;
}

[data-bs-theme="dark"] li.msg_wpp_render.received-message .ctext-wrap-content.deleted-content .group-sender-name {
    color: var(--brand-name-accent) !important; /* Tom claro da marca, para contraste no fundo escuro */
}

[data-bs-theme="dark"] .btn-read-more {
    color: #53bdeb;
}

.media-grid-container {
    position: relative;
    overflow: hidden;
    border-radius: 12px;
    background-color: transparent;
    max-width: 330px;
}

.media-grid-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2px;
    width: 100%;
}

.grid-item {
    position: relative;
    width: 100%;
    height: 120px;
    cursor: pointer;
    overflow: hidden;
}

.grid-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: transform 0.2s ease;
}

.grid-item:hover .grid-img {
    transform: scale(1.03);
    filter: brightness(0.9);
}

.grid-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 2rem;
    font-weight: 500;
    backdrop-filter: blur(2px);
}

.grid-item:first-child { border-top-left-radius: 12px; }
.grid-item:nth-child(2) { border-top-right-radius: 12px; }
.grid-item:nth-child(3) { border-bottom-left-radius: 12px; }
.grid-item:nth-child(4) { border-bottom-right-radius: 12px; }

.media-grid-wrapper:has(.grid-item:nth-child(3):last-child) .grid-item:nth-child(3) {
    border-bottom-right-radius: 12px;
}

.text-shadow {
    text-shadow: 0 1px 2px rgba(0,0,0,0.8);
}

.cursor-pointer {
    cursor: pointer;
}

.group-avatar-img:hover {
    filter: brightness(0.9);
    transform: scale(1.05);
    transition: transform 0.2s ease;
}

.media-loading-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.35);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
    transition: opacity 0.3s;
}

.file-loading-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255, 255, 255, 0.75);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
    transition: opacity 0.3s;
}

[data-bs-theme="dark"] .file-loading-overlay {
    background: rgba(0, 0, 0, 0.65);
}

.event-avatar {
    background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
    color: #059669;
    font-size: 24px;
    border-color: #a7f3d0;
}

[data-bs-theme="dark"] .event-avatar {
    background: linear-gradient(135deg, #064e3b 0%, #065f46 100%);
    color: #34d399;
    border-color: rgba(255,255,255,0.08);
}

/* Estilos modernos para overlays de estado (Loading e Erro) */
.media-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(3px);
    transition: all 0.3s ease;
}

.media-state-overlay.is-error {
    background: rgba(220, 53, 69, 0.7); /* Vermelho translúcido */
    cursor: pointer;
}

.media-state-overlay.is-error:hover {
    background: rgba(220, 53, 69, 0.85);
}

.error-action-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    color: white;
}

.retry-btn-modern {
    background: rgba(255, 255, 255, 0.2);
    border: 2px solid white;
    border-radius: 50%;
    width: 45px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
    transition: transform 0.2s;
}

.media-state-overlay.is-error:hover .retry-btn-modern {
    transform: rotate(45deg); /* Efeito sutil de girar ao passar o mouse */
}

.error-text {
    font-size: 13px;
    font-weight: 600;
    text-shadow: 0 1px 2px rgba(0,0,0,0.5);
    text-align: center;
}

/* Documentos */
.file-message-card.border-danger {
    border: 1px solid #dc3545 !important;
}

.file-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(255, 255, 255, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    z-index: 5;
    backdrop-filter: blur(2px);
}

[data-bs-theme="dark"] .file-state-overlay {
    background: rgba(30, 30, 30, 0.85);
}

.file-state-overlay.is-error {
    background: rgba(255, 235, 238, 0.95);
    cursor: pointer;
}

[data-bs-theme="dark"] .file-state-overlay.is-error {
    background: rgba(60, 20, 20, 0.95);
}

.error-action-content.file-error {
    flex-direction: row;
}
.error-action-content.file-error .error-text {
    text-shadow: none;
}

/* Overlay Moderno Geral */
.modern-state-overlay {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px; /* Acompanha a borda do seu card */
    z-index: 10;
    backdrop-filter: blur(2px);
    transition: all 0.25s ease;
}

/* Estado Vermelho Fofinho (Erro) */
.modern-state-overlay.is-failed {
    background: rgba(220, 53, 69, 0.75); /* Danger Bootstrap com opacidade */
    cursor: pointer;
}

.modern-state-overlay.is-failed:hover {
    background: rgba(220, 53, 69, 0.85);
}

.failed-action-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 10px;
}

.retry-circle {
    background: rgba(255, 255, 255, 0.25);
    border: 2px solid rgba(255, 255, 255, 0.8);
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 26px;
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    transition: transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

.modern-state-overlay.is-failed:hover .retry-circle {
    transform: scale(1.1) rotate(45deg); /* Efeito tátil muito satisfatório */
}

.failed-text {
    color: white;
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    line-height: 1.2;
    text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

/* --- ESTADO DE ERRO (FALHA NO ENVIO DO ARQUIVO) --- */
.file-message-card.is-failed-card {
    background-color: rgba(220, 53, 69, 0.04) !important; /* Fundo rosinha beeeem sutil */
    border: 1px solid rgba(220, 53, 69, 0.3) !important; /* Borda vermelha suave */
}

[data-bs-theme="dark"] .file-message-card.is-failed-card {
    background-color: rgba(220, 53, 69, 0.08) !important;
    border-color: rgba(220, 53, 69, 0.4) !important;
}

/* --- BOTÃO DE REENVIAR (RETRY) COM ANIMAÇÃO EFEITO WHATSAPP --- */
.retry-btn-modern {
    background-color: rgba(220, 53, 69, 0.1);
    color: #dc3545;
    border: none;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.25s ease;
}

.retry-btn-modern:hover {
    background-color: #dc3545;
    color: white;
    box-shadow: 0 4px 8px rgba(220, 53, 69, 0.25);
}

.retry-btn-modern i {
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

/* Gira a setinha quando passa o mouse */
.retry-btn-modern:hover i {
    transform: rotate(180deg);
}

/* Classes utilitárias do design */
.transition-all { transition: all 0.3s ease; }
.border-danger-subtle { border-color: rgba(220, 53, 69, 0.2) !important; }
.bg-danger-subtle { background-color: rgba(220, 53, 69, 0.1) !important; }
.bg-primary-subtle { background-color: rgba(13, 110, 253, 0.1) !important; }

/* --- ESTADO DE ERRO (FALHA NO ENVIO GERAL) --- */
.ctext-wrap-content.is-failed-message {
    background-color: rgb(254 241 241 / 74%) !important;
}

[data-bs-theme="dark"] .ctext-wrap-content.is-failed-message {
    background-color: rgba(220, 53, 69, 0.15) !important;
}

.text-failed-retry {
    display: inline-flex;
    align-items: center;
    color: #dc3545;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    margin-top: 8px;
    padding: 6px 10px;
    border-radius: 6px;
    background: rgba(220, 53, 69, 0.1);
    transition: all 0.2s ease;
    border: 1px solid rgba(220, 53, 69, 0.2);
}

.text-failed-retry:hover {
    background: rgba(220, 53, 69, 0.2);
    transform: translateY(-1px);
}

@media (max-width: 991.98px) {
    li.msg_wpp_render .conversation-list .ctext-wrap .ctext-wrap-content {
        max-width: 85vw !important; 
    }

    .image-message {
        width: 100%;
        max-width: 75vw; /* Mídias um pouco mais contidas */
    }

    .chat-media-fixed {
        height: auto; 
        max-height: 250px; /* Reduz a altura das imagens no celular */
    }

    li.msg_wpp_render {
        padding-right: 10px !important; 
    }
}

/* LIGHT THEME AUXILIARES */
[data-bs-theme=light] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.sent-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.sent-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.sent-message .pinned-icon {
    color: rgba(255, 255, 255, 0.9) !important;
}

[data-bs-theme=light] li.msg_wpp_render.received-message .chat-time,
[data-bs-theme=light] li.msg_wpp_render.received-message .audio-meta-row .chat-time-stamp,
[data-bs-theme=light] li.msg_wpp_render.received-message .favorite-star-icon,
[data-bs-theme=light] li.msg_wpp_render.received-message .pinned-icon {
    color: var(--bs-text-muted) !important;
}

/* DARK THEME AUXILIARES */
[data-bs-theme=dark] li.msg_wpp_render.sent-message .chat-time,
[data-bs-theme=dark] li.msg_wpp_render.sent-message .ack i {
    color: rgba(255, 255, 255, 0.7) !important;
}
[data-bs-theme=dark] li.msg_wpp_render.received-message .chat-time {
    color: var(--bs-text-muted) !important;
}

/* LINKS E BOTÃO "LER MAIS" */
[data-bs-theme=light] li.msg_wpp_render.sent-message :deep(.chat-link) { color: #84ffdf !important; text-decoration: underline; }
[data-bs-theme=light] li.msg_wpp_render.sent-message :deep(.chat-link:hover) { color: #68c3ab !important; }
[data-bs-theme=dark] li.msg_wpp_render.sent-message :deep(.chat-link) { color: #68b8ff !important; text-decoration: underline; }
[data-bs-theme=dark] li.msg_wpp_render.sent-message :deep(.chat-link:hover) { color: #249ccf !important; }

[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link) { color: #027eb5 !important; text-decoration: underline; }
[data-bs-theme=light] li.msg_wpp_render.received-message :deep(.chat-link:hover) { color: #027eb5 !important; }
[data-bs-theme=dark] li.msg_wpp_render.received-message :deep(.chat-link) { color: #53bdeb !important; text-decoration: underline; }

[data-bs-theme="light"] li.msg_wpp_render.sent-message .btn-read-more { color: #fff; text-shadow: 0 1px 1px rgba(0,0,0,0.1); }
[data-bs-theme="light"] li.msg_wpp_render.received-message .btn-read-more { color: #027eb5; text-shadow: none; }

/* CORES DOS NOMES */
li.msg_wpp_render.sent-message .agent-name-header,
li.msg_wpp_render.sent-message .group-sender-name {
    color: #ffffff !important;
    opacity: 1;
}

/* CORES DOS QUOTES (MENSAGENS RESPONDIDAS) */
.sent-message .quoted-reply-wrapper {
    background-color: rgb(255 255 255 / 24%);
    border-left: 4px solid var(--bs-success);
}
.sent-message .quoted-owner { color: #ffffff; }
.sent-message .quoted-snippet { color: #ffffff; opacity: 0.9; }

.received-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.05);
    border-left: 4px solid var(--bs-success);
}
.received-message .quoted-owner { color: var(--bs-primary); }
.received-message .quoted-snippet { color: var(--bs-text-muted); }

[data-bs-theme=dark] .sent-message .quoted-reply-wrapper {
    background-color: rgba(255, 255, 255, 0.15);
    border-left: 4px solid var(--bs-success);
}
[data-bs-theme=dark] .sent-message .quoted-owner { color: #ffffff; }
[data-bs-theme=dark] .sent-message .quoted-snippet { color: rgba(255, 255, 255, 0.85); }

[data-bs-theme=dark] .received-message .quoted-reply-wrapper {
    background-color: rgba(0, 0, 0, 0.1);
    border-left: 4px solid var(--bs-success);
}
[data-bs-theme=dark] .received-message .quoted-owner { color: var(--bs-primary); }
[data-bs-theme=dark] .received-message .quoted-snippet { color: var(--bs-text-muted); }
</style>